
export default {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
    },
    getters: {
        DATA: state => {
            return state.data;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        },
    },
    mutations: {
        DATA: (state, payload) => {
            return state.data = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_DATA: async ({state, dispatch}, payload) => {
            payload.th.showOverlay ++;
            let offset = state.perPage * (state.currentPage - 1)

            await payload.th.$store.dispatch('SEND_GET', {
                url: '/alert/message'
                    +'?limit='+ state.perPage
                    +'&offset='+ offset
                ,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    state.data = response.list
                    state.totalRows = response.count
                    dispatch('SWITCH_TO_READ',{th: payload.th})
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        SWITCH_TO_READ: async ({state}, payload) => {
            let idList = []
            for (let key in state.data) {
                idList.push(state.data[key].id)
            }
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/alert/message/switch',
                parameter: {
                    idList: idList
                },
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                }
            });
        }
    }
}